<!-- Changes not saved modal -->
<div class="modal fade changesNotSavedModal" tabindex="-1" role="dialog" id="changesNotSavedModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                    <div class="modal-body">
                        <ng-container *ngIf="activityType === 'cup-collab-task'">
                            <ng-container *ngIf="errorType === 'SUBMISSION_ERROR'">
                                <p>
                                    {{ 'SHARED.CHANGES_NOT_SAVED.FORGIVE_US_TEXT'| translate }}
                                </p>
                                <p class="font-weight-bold">
                                    {{ 'SHARED.CHANGES_NOT_SAVED.SOMETHING_WENT_WRONG'| translate }}
                                </p>
                                <p class="try-again">
                                    {{ 'SHARED.CHANGES_NOT_SAVED.PLEASE_TRY_AGAIN'| translate }}
                                </p>
                            </ng-container>
                            <ng-container *ngIf="errorType === 'OFFLINE_ERROR'">
                                <p>
                                    {{ 'SHARED.CHANGES_NOT_SAVED.SORRY_SOMETHING_WRONG_TEXT'| translate }}
                                </p>
                                <p class="try-again">
                                    {{ 'SHARED.CHANGES_NOT_SAVED.PLEASE_TRY_AGAIN'| translate }}
                                </p>
                            </ng-container>
                            <ng-container *ngIf="errorType !== 'OFFLINE_ERROR' && errorType !== 'SUBMISSION_ERROR'">
                                <p class="pt-3">
                                    {{ 'SHARED.CHANGES_NOT_SAVED.SORRY_PROBLEM_AT_OUR_END_TEXT'| translate }}
                                </p>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="activityType !== 'cup-collab-task'">
                            <p>
                                {{ 'SHARED.CHANGES_NOT_SAVED.FORGIVE_US_TEXT' | translate }}
                            </p>
                            <div *ngIf="activityType == 'speak' else others">
                                <p class="font-weight-bold">
                                    {{ 'SHARED.CHANGES_NOT_SAVED.RECORDING_NOT_SAVED' | translate }}
                                </p>
                                <p class="try-again" >
                                    {{ 'SHARED.CHANGES_NOT_SAVED.CHECK_TIPS' | translate }}
                                </p>
                                <p class="try-again tips">
                                     {{ 'SHARED.CHANGES_NOT_SAVED.FREE_SPACE' | translate }}
                                </p>  
                                <p class="try-again tips">
                                    {{ 'SHARED.CHANGES_NOT_SAVED.TIPS2' | translate }}
                               </p>  
                            </div>
                            <ng-template #others>
                                <p class="font-weight-bold">
                                    {{ 'SHARED.CHANGES_NOT_SAVED.SOMETHING_WENT_WRONG' | translate }}
                                </p>
                                <p class="last-saved" *ngIf="timeElapsed">
                                    {{ 'SHARED.CHANGES_NOT_SAVED.LAST_SAVED' | translate }} {{timeElapsed}}
                                </p>
                                <p class="try-again">
                                    {{ (errorType === 'URL_VALIDATION_ERROR' ? 'SHARED.CHANGES_NOT_SAVED.PLEASE_CHECK_URL_LINK' : 'SHARED.CHANGES_NOT_SAVED.PLEASE_TRY_AGAIN') | translate }}
                                </p>
                            </ng-template>
                        </ng-container>                   
                    </div>
                    <div class="modal-footer">
                            <button class="btn" data-dismiss="modal" qid="chngsNotSaved-1">
                                {{ 'SHARED.CHANGES_NOT_SAVED.OK' | translate }}
                            </button>
                    </div>
            </div>
    </div>
</div> 